import React from 'react'

const Component = ({ title, items }) => {
    const styles = {
        panel: {
            paddingTop: 10,
        },
        header: {
            paddingLeft: 5,
            paddingRight: 5,
            fontSize: '1.3rem',
            borderBottom: '4px solid #f7b500',
        },
        body: {
            paddingTop: 0,
            paddingBottom: 20,
            paddingLeft: 8,
        },
        item: {
            paddingTop: 20,
            display: 'flex',
            flexDirection: 'row',
            flexFlow: 'wrap',
            alignItems: 'center',
        },
        itemLabel: {},
        itemControl: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flex: '1 1 auto',
        },
        fill: {
            flex: '1 1 auto',
        },
    }

    return (
        <div style={styles.panel}>
            <div style={styles.header}>{title}</div>
            <div style={styles.body}>
                {items.map((item, index) =>
                    item.hidden ? null : (
                        <div style={{ ...styles.item }} key={index}>
                            <div style={styles.itemLabel}>{item.label}</div>
                            <div style={styles.itemControl}>
                                <div style={styles.fill} />
                                {item.control}
                            </div>
                        </div>
                    )
                )}
            </div>
        </div>
    )
}

export default Component
